import { TRootState } from 'store';

export const getEmail = (state: TRootState) => state.login.email;
export const getPassword = (state: TRootState) => state.login.password;
export const isLoading = (state: TRootState) => state.login.isLoading;
export const getError = (state: TRootState) => state.login.error;
